import { Box, Heading } from '@chakra-ui/react'
import React from 'react'

const PageNotfound = () => {
  return (
    <>
      <Box m="200px auto">
        <Heading textAlign={"center"}>Page Not Found 404</Heading>
      </Box>
    </>
  )
}

export default PageNotfound;
